module.exports = __webpack_public_path__ + "static/Dual-shore-model-c704b0ec33d0b2ba1c2c9ad5113e5fbb.png";